<template>
    <div class="login">
        <div class="login__box">
            <h1>
                <span>🤘</span>
                <slot name="title">Login</slot>
            </h1>
            <p><slot name="text">Login to get started</slot></p>

            <span v-if="loading">Loading...</span>

            <div class="login__box__buttons">
                <button @click="googleSignIn" class="button button--social">
                    <img src="@/assets/img/google.png" /> Login with Google
                </button>
                <button @click="facebookSignIn" class="button button--social">
                    <img src="@/assets/img/facebook.png" /> Login with Facebook
                </button>
                <span v-if="error" class="color--red">{{ error }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase";

export default {
    name: "Login",
    data() {
        return {
            loading: false,
            error: null
        };
    },
    methods: {
        googleSignIn: function() {
            let provider = new firebase.auth.GoogleAuthProvider();
            //var vm = this
            firebase.auth().signInWithPopup(provider).then((/*result*/) => {
                /*let token = result.credential.accessToken;
                let user = result.user;*/
                //vm.$router.push(this.$route.path)
            })
            .catch((err) => {
                console.log(err); // This will give you all the information needed to further debug any errors
            });
        },

        facebookSignIn: function() {
            let provider = new firebase.auth.FacebookAuthProvider();
            firebase.auth().signInWithPopup(provider).then((/*result*/) => {
                /*let token = result.credential.accessToken;
                let user = result.user;*/
                this.$router.push("/")
            })
            .catch((err) => {
                if(err.code === "auth/account-exists-with-different-credential") {
                    this.error = "This emailaddress already has an account, but not with Facebook login..."
                }
                console.log(err); // This will give you all the information needed to further debug any errors
            });
        }
    },
    /*created() {
        this.loading = true;
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.$store.commit('setCurrentUser', firebase.auth().currentUser)
                this.$router.push("/")
            }
            this.loading = false;
        });
    },*/
};
</script>